import React from "react";

import {
  DateField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { Typography } from "@material-ui/core";

import { BackButton } from "../../../components/common/BackButton";

const ShowActions = ({ basePath }) => (
  <TopToolbar>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

export const AnnouncementShow = (props) => {
  return (
    <Show {...props} title="Annoucement" actions={<ShowActions />}>
      <SimpleShowLayout>
        <TextField source="message" label="Message" nultiline />
        <Typography> {(record) => record.message} </Typography>
        <TextField source="link" label="Link" />
        <ReferenceField source="tenantId" reference="reloadYards" link="show">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="urgency" label="Urgency" />
        <DateField source="createdDateTime" label="Date Created" />
      </SimpleShowLayout>
    </Show>
  );
};
